import { useEffect, useState } from 'react';

import { DataGridPro } from '@mui/x-data-grid-pro';
import { Button, IconButton, Modal, Checkbox, Tooltip } from "@mui/material";
import Box from '@mui/material/Box';
import styled from 'styled-components';

import { useGetBuyingEmailWithPlatformsQuery, useLazyDecryptEmailPasswordQuery } from '../../../../services/buyingEmailApi.js';

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

import editIcon from "../../../../img/pencil-icon.svg";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

import BuyingEmailForm from '../BuyingEmailForm.jsx';
import { useNotification } from '../../../../context/NotificationContext';

function getIsActiveIcon(params) {
  const CheckIcon = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: "center" }}>
      <CheckOutlinedIcon color="success" />
    </Box>
  )

  const InactiveIcon = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: "center" }}>
      <CloseIcon sx={{ color: "var(--red)", margin: "auto" }} />
    </Box>
  )

  return (
    params.row.isActive ? <CheckIcon /> : <InactiveIcon />
  )
}

function BEPasswordCell({ params, passwordChange }) {

  const [initDecrypt] = useLazyDecryptEmailPasswordQuery();
  const passwordDflt = "********";
  const [password, setPassword] = useState(passwordDflt);

  async function handleClickShowPassword() {
    if (password === passwordDflt) {
      let res = await initDecrypt(params.row.id).unwrap();
      console.log(res)
      setPassword(res?.data?.mailboxPassword);
    } else {
      setPassword(passwordDflt);
    }
  }

  useEffect(() => {
    if (passwordChange) {
      if (parseInt(passwordChange.buyingEmailId) === parseInt(params.row.id)) {
        setPassword(passwordDflt);
      }
    }
  }, [passwordChange]);

  return (
    <div>
      <span style={{ margin: '0 0.5em 0 0' }} >{password}</span>
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClickShowPassword}
        edge="end"
      >
        {password === passwordDflt
          ?
          <VisibilityOffOutlinedIcon color='primary' />
          :
          <VisibilityOutlinedIcon color='primary' />
        }
      </IconButton>
    </div>
  );
}

export default function BuyingEmailsForUser({ userId, isBeeViewing }) {

  const { showNotification } = useNotification();

  //A: first step bring all buyingEmail for user
  const [showOnlyActiveEmails, setShowOnlyActiveEmails] = useState(true);
  const { data: buyingEmails, isFetching: isBuyingEmailLoading } = useGetBuyingEmailWithPlatformsQuery({ AssignedUserID: userId, IsActive: showOnlyActiveEmails == true ? true : null }, { skip: !userId });

  const [openAddEmailModal, setOpenAddEmailModal] = useState(null);
  const [passwordChange, setPasswordChange] = useState(null);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  const columns = [
    {
      field: 'id',
      hide: true,
      headerName: 'ID',
      flex: 1
    },
    {
      field: 'emailAddress',
      renderHeader: () => (
        <Tooltip style={{ fontSize: "44px" }} title="Emails used for all your EncoreHive related work. Not for personal use." placement='top-start'>
          <div style={{ display: 'flex', alignItems: 'center', fontWeight: '500' }} >
            <EmailOutlinedIcon color='primary' sx={{ margin: ' 0 0.25em 0 0' }} />
            {'BUYING EMAIL'}
          </div>
        </Tooltip>
      ),
      flex: 1
    },
    {
      field: 'password',
      renderHeader: () => (
        <Tooltip title="Password for logging into the mailbox of buying email." placement='top-start' >
          <div style={{ display: 'flex', alignItems: 'center', fontWeight: '500' }} >
            <KeyOutlinedIcon color='primary' sx={{ margin: ' 0 0.25em 0 0' }} />
            {'MAILBOX PASSWORD'}
          </div>
        </Tooltip>
      ),
      renderCell: (params) => <BEPasswordCell params={params} passwordChange={passwordChange} />,
      flex: 1
    },
    {
      field: 'isActive',
      headerName: 'ACTIVE',
      renderCell: (params) => getIsActiveIcon(params),
      headerAlign: "center",
      alignItems: "center",
      flex: 0
    },
    {
      field: 'actions',
      headerName: '',
      renderCell: (params) => <EditBuyingEmailCell params={params} />,
      width: 120
    },
  ]

  function EditBuyingEmailCell({ params }) {

    function handleClickShowPassword() {
      let userId = params.row.assignedUserID;
      let emailId = params.row.id;
      let assignedUserName = params.row.assignedUserName;
      let assignedUserData = params.row.assignedUser;
      setOpenAddEmailModal({
        userId: userId,
        emailId: emailId,
        title: `Edit Buying Email`
      })
    }

    return (
      <>
        <Button
          className="button-edit"
          onClick={() =>
            handleClickShowPassword()
          }
        >
          <img src={editIcon} alt="edit icon" height="18px" width="18px" />
          <span style={{ marginLeft: "0.5em", color: ' var(--orange) ' }}>View/Edit</span>
        </Button>
      </>
    );
  }


  function onBuyingEmailFormError(error, message) {
    showNotification(message, 'error');
  }

  function onBuyingEmailFormSuccess(res, message) {
    showNotification(message, 'success');

    setPasswordChange({ buyingEmailId: parseInt(res.buyingEmail.id) })
  }

  return <>
    <div className='table-option-container'>
      {
        !isBeeViewing &&
        <div style={{ margin: '0 0.5em 0.5em 0' }}>
          <Checkbox type="checkbox" id="showInactiveCards" name="SHOW INACTIVE BUYING EMAILS" onClick={() => setShowOnlyActiveEmails(prev => !prev)} />
          <label htmlFor="showInactiveCards" style={{ fontSize: "14px", color: "var(--orange)" }} >SHOW INACTIVE BUYING EMAILS</label>
        </div>
      }
      <Button style={{ marginBottom: '0.5em' }}
        onClick={() => {
          setOpenAddEmailModal({
            userId: userId,
            title: `Add New Buying Email`
          });
        }}
      >
        ADD NEW BUYING EMAIL
      </Button>
    </div>
    <DataGridPro
      rows={buyingEmails || []}
      columns={columns}
      rowHeight={38}
      loading={isBuyingEmailLoading}
      disableSelectionOnClick
      sx={{ borderRadius: "1em", backgroundColor: 'white', padding: '1em', height: "90%" }}
      initialState={{
        sorting: {
          sortModel: [{ field: 'emailAddress', sort: 'asc' }],
        },
      }}
    />

    <Modal
      open={Boolean(openAddEmailModal)}
      onClose={() => setOpenAddEmailModal(null)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <BuyingEmailForm
          title={openAddEmailModal?.title}
          userId={openAddEmailModal?.userId}
          emailId={openAddEmailModal?.emailId}
          onClose={() => setOpenAddEmailModal(null)}
          onSuccess={onBuyingEmailFormSuccess}
          onError={onBuyingEmailFormError}
          beeIsEditing={isBeeViewing}
        />
      </Box>
    </Modal>
  </>
}
